export default __webpack_public_path__ + "static/media/materialize-5.839c9dce.jpg";